module.exports = __webpack_public_path__ + "static/media/rubydp.a3468c8b.jpg";